const ChevronIcon = ({
  className = "text-activeColor",
}: {
  className?: string;
}) => {
  return (
    <svg
      className={className}
      fill="none"
      height="20"
      viewBox="0 0 21 20"
      width="21"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.0989 3.39961L7.43915 8.83294C6.77075 9.47461 6.77075 10.5246 7.43915 11.1663L13.0989 16.5996"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
    </svg>
  );
};

export default ChevronIcon;
